import { FC } from "react";
import { useSelector } from "react-redux";

import styles from "../headerBtn.module.scss";
import { reducerExpiredRecordsModalCreateValues } from "../../../redux/reducer/userReports/reducers/expiredReports";
import CustomMultiSelect from "../../custom/customMultiSelect/customMultiSelect";
import clsx from "clsx";

const CreateExpiredReportsSection: FC = () => {
  const { projectOptions, merchsOptions, svsOptions, vsvsOptions } =
    useSelector((state: any) => state.userReports.userReports);

  const { expiredRecordsModalCreateValues, reports, reportsId } = useSelector(
    (state: any) => state.userReports.expiredReports
  );
  const reportsWithData: any = [];
  reportsId.map((reportId: any) =>
    reportsWithData.push(
      reports.filter(
        (report: any) => report.expiredReport.id === reportId.id
      )[0]
    )
  );

  return (
    <div className={styles.block__info}>
      <div className={styles.block__info__row}>
        <div
          className={clsx(
            "multiselect__filter_block",
            styles.block__info__column
          )}
        >
          <CustomMultiSelect
            reducer={reducerExpiredRecordsModalCreateValues}
            inputValues={expiredRecordsModalCreateValues}
            action={() => {}}
            options={projectOptions}
            isShowPlaceholder={true}
            placeholder="Проект"
            name="projects"
            maxSelect={1}
            pageName="expiredReportsModal"
          />
        </div>

        <div
          className={clsx(
            "multiselect__filter_block",
            styles.block__info__column
          )}
        >
          <CustomMultiSelect
            reducer={reducerExpiredRecordsModalCreateValues}
            inputValues={expiredRecordsModalCreateValues}
            action={() => {}}
            placeholder="Мерчендайзер"
            isShowPlaceholder={true}
            options={merchsOptions}
            name="merchs"
            maxSelect={1}
            pageName="expiredReportsModal"
          />
        </div>
      </div>

      <div className={styles.block__info__row}>
        <div className={clsx(
            "multiselect__filter_block",
            styles.block__info__column
          )}>
            <CustomMultiSelect
              reducer={reducerExpiredRecordsModalCreateValues}
              inputValues={expiredRecordsModalCreateValues}
              action={() => {}}
              placeholder="Супервайзер"
              isShowPlaceholder={true}
              options={svsOptions}
              name="svs"
              maxSelect={1}
              pageName="expiredReportsModal"
            />
          </div>

        <div className={clsx(
            "multiselect__filter_block",
            styles.block__info__column
          )}>
            <CustomMultiSelect
              reducer={reducerExpiredRecordsModalCreateValues}
              inputValues={expiredRecordsModalCreateValues}
              action={() => {}}
              placeholder="Виртуальный супервайзер"
              isShowPlaceholder={true}
              options={vsvsOptions}
              name="vsv"
              maxSelect={1}
              pageName="expiredReportsModal"
            />
        </div>
      </div>
    </div>
  );
};

export default CreateExpiredReportsSection;
